import { Component, OnInit } from '@angular/core';
import {ModalController, NavParams} from '@ionic/angular';
import{ApiService} from '../../../services/api.service';

@Component({
  selector: 'app-input-nilai',
  templateUrl: './input-nilai.page.html',
  styleUrls: ['./input-nilai.page.scss'],
})
export class InputNilaiPage implements OnInit {

  constructor(private modalCtrl:ModalController, private api:ApiService) { }

  ngOnInit() {
    this.getSiswa();
    this.getDataBobot();
    this.getDataKonversi();
  }

  kelas:any={};
  program:any={};
  dataProgramPenilaian:any=[];
  closeModal()
  {
    this.modalCtrl.dismiss();
  }

  siswa:any=[];
  getSiswa()
  {
      var params='tahunID='+this.kelas.tahunID+'&semester='+this.kelas.semester+'&mapelID='+this.kelas.mapelID+'&tingkatID='+this.kelas.tingkat+'&kelasID='+this.kelas.kelasID;
      this.api.data('api/nilai?'+params,'get','').subscribe(data=>{
        this.parseSiswa(data);
      })
  }
  parseSiswa(data)
  {
      for(var i=0; i<data.length; i++)
      {
          var val=this.testJSON(data[i].nilai.data);         
          if(val)
          {
              var nn=JSON.parse(data[i].nilai.data);
              if(typeof nn==='object')
              data[i].nilai.data=nn
              else
              data[i].nilai.data={};              
          }else{
              data[i].nilai.data={};
          }          
      }
      this.siswa=data;
  }

  testJSON(text){
    if (typeof text!=="string"){
        return false;
    }
    try{
        JSON.parse(text);
        return true;
    }
    catch (error){
        return false;
    }
  }

  dataBobot:any={};
  getDataBobot()
  {
      this.api.data('akademik/bobot?tahun='+this.kelas.tahunID,'get','').subscribe(data=>{
          this.dataBobot=data;
      })
  }
  dataKonversi:any=[];
  getDataKonversi()
  {
      this.api.data('api/find/config_konversi','get','').subscribe(data=>{
        this.dataKonversi=data;
      })
  }

  kategoriPenilaian:any=[
            {
                label:'UH',
                nama:'Ulangan Harian'
            },
            {
                label:'T',
                nama:'Tugas'
            },
            {
                label:'UTS',
                nama:'UTS'
            },
            {
                label:'UAS',
                nama:'UAS'
            }
        ];

  hitungRapot(dat)
  {   
    var kat=this.program.kategori;
    var kp=this.kategoriPenilaian;
    var uh=[], t=[], uts=[], uas=[],des=[];
    for(var j=0; j<kp.length; j++)
    {
      var data=this.dataProgramPenilaian;
      for(var i=0; i<data.length; i++)
      {
        var nilai;
        if(dat.nilai.data[data[i].kode]==null) nilai=0;
        else nilai=dat.nilai.data[data[i].kode];

        var ds={
          program:data[i].kode,
          nilai:nilai,
          kompetensi:' '+data[i].kompetensi
        };

        if(data[i].jenis=='UH'){
          uh.push(nilai);
          des.push(ds);
        }
        if(data[i].jenis=='T') {
          t.push(nilai);
          des.push(ds);
        }
        if(data[i].jenis=='UTS') uts.push(nilai);
        if(data[i].jenis=='UAS') uas.push(nilai);
      }
    }
    var naUH, naT, naUTS, naUAS, na;
    if(uh.length>0)
    naUH=uh.reduce(this.getSum)/uh.length*Number(this.dataBobot.uh)/100;
    else naUH=0;
    if(t.length>0)
    naT=t.reduce(this.getSum)/t.length*Number(this.dataBobot.tugas)/100;
    else naT=0;
    if(uts.length>0)
    naUTS=uts.reduce(this.getSum)/uts.length*Number(this.dataBobot.uts)/100;
    else naUTS=0;
    if(uas.length>0)
    naUAS=uas.reduce(this.getSum)/uas.length*Number(this.dataBobot.uas)/100;
    else naUAS=0;
    na=Number(naUH+naT+naUTS+naUAS);
    
    //definisi
    dat.nilai.rapot_angka[kat]=na;
    dat.nilai.rapot_predikat[kat]=this.konversi(na);
    dat.nilai.rapot_deskripsi[kat]=this.deskripsi(des);    
    this.updateNilai(dat);
  }
  loading:any={};
  updateNilai(dataSiswa)
  {
    this.loading[dataSiswa.siswaID]=true;
    var dat={
        keys:{id:dataSiswa.nilai.id},
        data:{
        data:JSON.stringify(dataSiswa.nilai.data),
        rapot_angka:JSON.stringify(dataSiswa.nilai.rapot_angka),
        rapot_predikat:JSON.stringify(dataSiswa.nilai.rapot_predikat),
        rapot_deskripsi:JSON.stringify(dataSiswa.nilai.rapot_deskripsi)
        }
      };
    var i=this.siswa.map(function(e){return e.siswaID}).indexOf(dataSiswa.siswaID);
    if(dataSiswa.nilai.id!=undefined)
    {
      this.api.data('api/update/'+dataSiswa.nilai.db_nilai,'put',{data:dat}).subscribe(data=>{
        this.siswa[i].success=true;    
        this.loading[dataSiswa.siswaID]=false; 
      }, error=>{
        this.siswa[i].success=false;    
      })
    }else{
      var dt=dat.data;
      dt['mapelID']=this.kelas.mapelID;
      dt['siswaID']=dataSiswa.siswaID;
      dt['tingkat']=this.kelas.tingkat;
      dt['tahun']=this.kelas.tahunID;
      dt['semester']=this.kelas.semester;
      console.log(dt);
      this.api.data('api/create/'+dataSiswa.nilai.db_nilai,'post',{data:dt}).subscribe(data=>{
        this.siswa[i].success=true;
        this.loading[dataSiswa.siswaID]=false;   
      }, error=>{
        this.siswa[i].success=false;    
      })
    }
  }

  deskripsi(data)
  {
    var dat={};
    for(var i=0; i<data.length; i++)
    {
      var predikat=this.konversi(data[i].nilai);
      if(dat[predikat]==undefined)
      {
        dat[predikat]=[];
        dat[predikat].push(data[i].kompetensi);
      }else{
        dat[predikat].push(data[i].kompetensi);
      }     
    }
    return this.konversiText(dat);
  }

  konversiText(data)
  {
    var txt='';
    for(var i=0; i<this.dataKonversi.length; i++)
    {
      if(data[this.dataKonversi[i].predikat]!=undefined)
      txt+=(this.dataKonversi[i].keterangan+' dalam '+data[this.dataKonversi[i].predikat].toString()+'. ');
    }
    return txt;
  }

  konversi(n)
  {
    var dat=[];
    for(var i=0; i<this.dataKonversi.length; i++)
    {
      var nilai=Number(this.dataKonversi[i].batas_bawah);
      var delta=Math.sqrt((nilai-n)*(nilai-n));
      dat.push(Math.floor(delta));
    }
    var min=Math.min.apply(null,dat);
    var idx=dat.indexOf(min);
    if(n<Number(this.dataKonversi[idx].batas_bawah)) idx=idx+1;
    if(this.dataKonversi[idx]!=undefined)
    return this.dataKonversi[idx].predikat;
    else return;
  }

  getSum(total, num) {
    return total + num;
  }

}
